// @/types/modules/core/frequency.ts
export enum FrequencyType {
  Default = 'Default',
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Yearly = 'Yearly',
}

export interface FrequencyOption {
  type: FrequencyType;
  label: string;
}

export type ModeKey =
  | 'Default'
  | 'Daily'
  | 'EveryDays'
  | 'Weekly'
  | 'EveryWeeks'
  | 'Monthly'
  | 'EveryMonths'
  | 'Quarterly'
  | 'EveryQuarters'
  | 'Yearly'
  | 'EveryYears';

export const MODE_KEYS = [
  'Daily',
  'EveryDays',
  'Weekly',
  'EveryWeeks',
  'Monthly',
  'EveryMonths',
  'Quarterly',
  'EveryQuarters',
  'Yearly',
  'EveryYears',
] as const satisfies readonly ModeKey[];
